const React = require('react');
const CircularProgress = require('@material-ui/core/CircularProgress').default;
const IconButton = require('@material-ui/core/IconButton').default;
const ErrorIcon = require('../../../icons/Error');
const CloseIcon = require('../../../icons/Close');
const CheckB = require('../../../icons/CheckB');
const Slot = require('./Slot');


module.exports = (props) => {
  const {
    progress,
  } = props;

  const elRemoveBtn = (
    <IconButton
      className="rlv*2 c0*2 z1 dn o50 o100:h"
      onClick={props.onRemove}
    >
      <CloseIcon className="w14 c0"/>
    </IconButton>
  );

  return (
    <Slot
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <div
        className="tc w f12 fw7 lts0em"
      >{props.labelHeader}</div>
      <div className="abs sh st48">
        {
          props.loading ? (
            <>
              <div className="layoutRow fhaC fvaC">
                <div className="rlv">
                  <CircularProgress
                    className="dB*2 c0*2"
                    variant="determinate"
                    size={44}
                    value={progress}
                  />
                  <div
                    className="abs s layoutRow fhaC fvaC f11"
                  >{progress.toFixed(0)}%</div>
                </div>
              </div>
              <div className="layoutRow fhaC fvaC">
                <div className="layoutRow fhaS fvaC wmax pl20 pr5">
                  <div
                    className="mr5 tl f12 fw3 lh130% lts0em"
                  >Uploading...</div>
                  {elRemoveBtn}
                </div>
              </div>
            </>
          ) : (
            props.error ? (
              <>
                <div className="layoutRow fhaC fvaC w">
                  <ErrorIcon className="sq44 o30"/>
                </div>
                <div className="layoutRow fhaC fvaC">
                  <div className="layoutRow fhaS fvaC wmax pl20 pr5">
                    <div className="mr5 tl f12 fw3 lh130% lts0em cF00">
                      <div>Failed to upload file!</div>
                      <div>Try again</div>
                    </div>
                    {elRemoveBtn}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="layoutRow fhaC fvaC w">
                  <CheckB className="sq44"/>
                </div>
                <div className="layoutRow fhaC fvaC">
                  <div className="layoutRow fhaS fvaC wmax pl20 pr5">
                    <div
                      className="mr5 tl f12 fw3 lh130% lts0em ov ws tov"
                    >{props.name || 'file'}</div>
                    {elRemoveBtn}
                  </div>
                </div>
              </>
            )
          )
        }
      </div>
    </Slot>
  );
};
